
import axios from "@/axios.js"

export default {
  fetchItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/secteurs")
        .then((response) => {
          commit('SET_ITEMS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsWithInterventions({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/secteursWithInterventions")
        .then((response) => {
          commit('SET_ITEMS_WITH_INTERVENTIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/secteur", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(response.data.secteur, {id: response.data.secteur.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/secteur/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM', response.data.secteur)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/secteur/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },




}
